module.exports = __webpack_public_path__ + "static/media/letter-4-min.2d622dd6.png";